// src/validators/validationSchema.js
import * as yup from 'yup';

export const validationSchema = yup.object({
    enquiry_type: yup.string().required("You must select an enquiry type"),
    message: yup.string().required("You must enter a message"),
});